(function () {
    "use strict";

    function checkCooldown() {
        const lastClosed = localStorage.getItem("g-pop-box-closed");
        if (lastClosed) {
            const closedTime = new Date(lastClosed);
            const now = new Date();
            const diffDays = (now - closedTime) / (1000 * 60 * 60 * 24);
            return diffDays < 3;
        }
        return false;
    }

    function setCooldown() {
        localStorage.setItem("g-pop-box-closed", new Date().toISOString());
    }

    function injectCSS() {
        const style = document.createElement("style");
        style.innerHTML = `

  html {
    font-size: 12px;
  }
  .g-pop-box {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 9999;
    touch-action: pan-y;
  }
  .g-pop-box .g-pop-mark {
    height: 100%;
    width: 100%;
    background: rgba(0, 0, 0, 0.5);
  }
  .g-pop-box .g-pop-ab-main {
    display: flex;
    background: #fff;
    flex-direction: column;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    border-radius: 1.6rem;
    /* Keep the page locked, but let oversized popup content scroll here. */
    max-height: calc(100vh - 2rem);
    max-height: calc(100dvh - 2rem);
    overflow-x: hidden;
    overflow-y: auto;
    -webkit-overflow-scrolling: touch;
    overscroll-behavior: contain;
    touch-action: pan-y;
    width: 100%;
    max-width: 51.58rem;
    box-sizing: border-box;
  }
  .g-pop-box .g-pop-ab-main .g-pop-main {
    position: relative;
    display: flex;
    flex-direction: column;
  }

  .g-pop-box .g-pop-ab-main .g-pop-main .g-pop-close {
    position: absolute;
    top: 3.6rem;
    right: 4rem;
    z-index: 4;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 4rem;
    height: 4rem;
    padding: 0;
    border: 0;
    background: transparent;
    color: inherit;
    cursor: pointer;
    touch-action: manipulation;
    -webkit-appearance: none;
    appearance: none;
  }

  .g-pop-box .g-pop-ab-main .g-pop-main .g-pop-close>svg {
    width: 2rem;
    height: 2rem;
    pointer-events: none;
  }

  .g-pop-box .g-pop-ab-main .g-pop-main .g-pop-main-bg {
    object-fit: cover;
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: auto;
    z-index: 2;
  }


  .g-pop-box .g-pop-ab-main .g-pop-main .g-pop-main-bg.g-pop-main-bg_m {
    display: none;
  }

  .g-pop-box .g-pop-ab-main .g-pop-main .g-pop-heading {
    display: grid;
    grid-template-columns: auto minmax(0, 1fr);
    align-items: flex-start;
    column-gap: 1.5rem;
    row-gap: 0;
    margin-top: 4rem;
    padding: 0 4rem;
    z-index: 3;
  }

  .g-pop-box .g-pop-ab-main .g-pop-main .g-pop-heading .g-pop-main-icon {
    flex: 0 0 auto;
    margin: 0;
  }

  .g-pop-box .g-pop-ab-main .g-pop-main .g-pop-heading .g-pop-title {
    min-width: 0;
    margin-top: 0;
    padding: 0;
  }

  .g-pop-box .g-pop-ab-main .g-pop-main .g-pop-heading .g-pop-title-first-line {
    white-space: nowrap;
  }

  .g-pop-box .g-pop-ab-main .g-pop-main .g-pop-heading .g-pop-title-second-line {
    grid-column: 1 / -1;
    white-space: nowrap;
  }

  .g-pop-box .g-pop-ab-main .g-pop-main .g-pop-main-icon {
    width: 5.2rem;
    margin-top: 4rem;
    margin-left: 4rem;
    height: auto;
    object-fit: cover;
    z-index: 3;
  }

  .g-pop-box .g-pop-ab-main .g-pop-main .g-pop-main-icon.g-pop-main-icon_success {
    display: none;
  }

  .g-pop-box .g-pop-ab-main .g-pop-main .g-pop-title {
    font-family: MiSans;
    font-weight: bold;
    font-size: 4rem;
    color: #000000;
    text-align: left;
    font-style: normal;
    margin-top: 0.83rem;
    padding: 0 4rem;
    max-width: 58.25rem;
    z-index: 3;
    line-height: normal;
  }

  .g-pop-box .g-pop-ab-main .g-pop-main .g-pop-title.g-pop-title_success {
    display: none;
  }

  .g-pop-box .g-pop-ab-main .g-pop-main .g-pop-title .g-pop-title-highlight {
    color: #005ffc;
  }

  .g-pop-box .g-pop-ab-main .g-pop-main .g-pop-sub-title {
    font-family: MiSans;
    font-weight: 400;
    font-size: 1.67rem;
    color: rgba(0, 0, 0, 0.5);
    z-index: 3;
    text-align: left;
    font-style: normal;
    margin-top: 0.83rem;
    padding: 0 4rem;
    max-width: 43.58rem;
  }

  .g-pop-box .g-pop-ab-main .g-pop-main .g-pop-sub-title.g-pop-sub-title_success {
    display: none;
  }

  .g-pop-box .g-pop-ab-main .g-pop-main .g-pop-button-box {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: 1.68rem 4rem 2.33rem;
  }

  .g-pop-box .g-pop-ab-main .g-pop-main .g-pop-button-box .g-pop-button-input {
    width: 100%;
    border-radius: 0.38rem;
    border: 0.17rem solid #000000;
    padding: 1.67rem 1.5rem;
    font-family: MiSans;
    font-weight: 400;
    font-size: 1.67rem;
    line-height: 2rem;
    max-height: 5.33rem;
    color: #000000;
    text-align: left;
    font-style: normal;
    outline: none;
    margin-bottom: 0rem;
    transition: all 0.5s;
    box-shadow: none;
    max-width: 100%;
    box-sizing: border-box;
    z-index:9;
  }

  .g-pop-box .g-pop-ab-main .g-pop-main .g-pop-button-box .g-pop-button-input::placeholder {
    color: #8a8a8a;
  }

  .g-pop-box .g-pop-ab-main .g-pop-main .g-pop-button-box .g-pop-button-error-text {
    margin-top: 0.6rem;
    font-family: MiSans;
    font-weight: 400;
    font-size: 1.67rem;
    color: red;
    width: 100%;
    display: none;
  }

  .g-pop-box .g-pop-ab-main .g-pop-main .g-pop-button-box .g-pop-button-copy-box {
    display: none;
  }

  .g-pop-box .g-pop-ab-main .g-pop-main .g-pop-button-box .g-pop-button-input:hover,
  .g-pop-box .g-pop-ab-main .g-pop-main .g-pop-button-box .g-pop-button-input:focus,
  .g-pop-box .g-pop-ab-main .g-pop-main .g-pop-button-box .g-pop-button-input:active {
    border-color: #005ffc !important;
  }

  .g-pop-box .g-pop-ab-main .g-pop-main .g-pop-button-box .g-pop-button-input.g-pop-button-input_error {
    border-color: red !important;
  }

  .g-pop-box .g-pop-ab-main .g-pop-main .g-pop-button-box .g-pop-button-button {
    font-family: MiSans;
    font-weight: 600;
    font-size: 1.51rem;
    color: #ffffff;
    line-height: 2.17rem;
    text-align: center;
    padding: 1.58rem 0;
    width: 100%;
    outline: none;
    border: none;
    background: #005ffc;
    cursor: pointer;
    transition: all 0.5s;
    margin-top: 2rem;
    border-radius: 0.38rem 0.38rem 0.38rem 0.38rem;
  }

  .g-pop-box .g-pop-ab-main .g-pop-main .g-pop-button-box .g-pop-button-button span:nth-child(2) {
    display: none;
  }

  .g-pop-box .g-pop-ab-main .g-pop-main .g-pop-button-box .g-pop-button-button:hover {
    background: #0059ed;
  }

  .g-pop-box .g-pop-ab-main .g-pop-main .g-pop-button-box .g-pop-button-button.g-pop-button-button_not {
    background: #b3cffe;
    cursor: not-allowed;
    position: relative;
  }

  .g-pop-box .g-pop-ab-main .g-pop-main .g-pop-button-box .g-pop-button-button.g-pop-button-button_not::after {
    content: "";
    display: inline-block;
    width: 20px;
    height: 20px;
    border: 2px solid #fff;
    border-radius: 50%;
    border-top-color: transparent;
    animation: spin 1s linear infinite;
    margin: 0;
  }

  .g-pop-box .g-pop-ab-main .g-pop-main .g-pop-button-box .g-pop-button-button.g-pop-button-button_not>span {
    display: none;
  }

  @keyframes spin {
    0% {
      transform: rotate(0deg);
    }

    100% {
      transform: rotate(360deg);
    }
  }

  .g-pop-box .g-pop-ab-main .g-pop-main .g-pop-button-box .g-pop-cancle {
    font-family: MiSans;
    font-weight: 400;
    font-size: 1.67rem;
    margin-top: 2rem;
    color: rgba(0, 0, 0, 0.5);
    cursor: pointer;
    text-align: center;
    font-style: normal;
  }

  .g-pop-box .g-pop-ab-main.g-pop-ab-main_success .g-pop-main-icon {
    display: none;
  }

  .g-pop-box .g-pop-ab-main.g-pop-ab-main_success .g-pop-heading {
    display: none;
  }

  .g-pop-box .g-pop-ab-main.g-pop-ab-main_success .g-pop-main-icon.g-pop-main-icon_success {
    display: block;
    width: 5.42rem;
    top: 4.5rem;
    height: 5.42rem;
  }

  .g-pop-box .g-pop-ab-main.g-pop-ab-main_success .g-pop-main .g-pop-title {
    display: none;
  }

  .g-pop-box .g-pop-ab-main.g-pop-ab-main_success .g-pop-main .g-pop-title.g-pop-title_success {
    display: block;
    top: 11.5rem;
    left: 4rem;
    font-family: MiSans;
    font-weight: bold;
    font-size: 4rem;
    color: #000000;
    text-align: left;
    font-style: normal;
  }

  .g-pop-box .g-pop-ab-main.g-pop-ab-main_success .g-pop-main .g-pop-sub-title {
    display: none;
  }

  .g-pop-box .g-pop-ab-main.g-pop-ab-main_success .g-pop-main .g-pop-sub-title.g-pop-sub-title_success {
    top: 23rem;
    font-family: MiSans;
    display: block;
    font-weight: 400;
    font-size: 1.67rem;
    color: rgba(0, 0, 0, 0.5);
    text-align: left;
    font-style: normal;
  }

  .g-pop-box .g-pop-ab-main.g-pop-ab-main_success .g-pop-button-box {
    padding: 1.92rem 4rem 6.58rem;
  }

  .g-pop-box .g-pop-ab-main.g-pop-ab-main_success .g-pop-button-box .g-pop-button-input {
    display: none;
  }

  .g-pop-box .g-pop-ab-main.g-pop-ab-main_success .g-pop-button-box .g-pop-button-copy-box {
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;
    z-index:9;
  }

  .g-pop-box .g-pop-ab-main.g-pop-ab-main_success .g-pop-button-box .g-pop-button-copy-box .g-pop-button-copy-bg {
    display: block;
  }

  .g-pop-box .g-pop-ab-main.g-pop-ab-main_success .g-pop-button-box .g-pop-button-copy-box .g-pop-button-copy-bg.g-pop-button-copy-bg_m {
    display: none;
  }

  .g-pop-box .g-pop-ab-main.g-pop-ab-main_success .g-pop-button-box .g-pop-button-copy-box .g-pop-button-copy-main {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    display: flex;
    align-items: center;
    justify-content: center;
    font-family: MiSans;
    font-weight: 400;
    font-size: 1.67rem;
    color: #000000;
    text-align: left;
    font-style: normal;
  }

  .g-pop-box .g-pop-ab-main.g-pop-ab-main_success .g-pop-button-box .g-pop-button-copy-box .g-pop-button-copy-main>span:nth-child(2) {
    font-weight: 600;
    margin-right: 0.5rem;
  }

  .g-pop-box .g-pop-ab-main.g-pop-ab-main_success .g-pop-button-box .g-pop-button-copy-box .g-pop-button-copy-main .g-pop-button-copy-icon-box {
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .g-pop-box .g-pop-ab-main.g-pop-ab-main_success .g-pop-button-box .g-pop-button-copy-box .g-pop-button-copy-main .g-pop-button-copy-icon-box>svg {
    cursor: pointer;
  }

  .g-pop-box .g-pop-ab-main.g-pop-ab-main_success .g-pop-button-box .g-pop-button-copy-box .g-pop-button-copy-main .g-pop-button-copy-icon-box .g-pop-button-copy-icon-tips-box {
    position: absolute;
    display: none;
    align-items: center;
    justify-content: center;
    padding: 0.58rem 1rem 0.67rem 0.67rem;
    border-radius: 0.5rem;
    background: #3e3e3e;
    top: -100%;
    left: 50%;
    transform: translate(-50%, -50%);
  }

  .g-pop-box .g-pop-ab-main.g-pop-ab-main_success .g-pop-button-box .g-pop-button-copy-box .g-pop-button-copy-main .g-pop-button-copy-icon-box .g-pop-button-copy-icon-tips-box.g-pop-button-copy-icon-tips-box_active {
    display: flex;
  }

  .g-pop-box .g-pop-ab-main.g-pop-ab-main_success .g-pop-button-box .g-pop-button-copy-box .g-pop-button-copy-main .g-pop-button-copy-icon-box .g-pop-button-copy-icon-tips-box>svg {
    height: 1.67rem;
    width: 1.67rem;
    margin-right: 0.33rem;
  }

  .g-pop-box .g-pop-ab-main.g-pop-ab-main_success .g-pop-button-box .g-pop-button-copy-box .g-pop-button-copy-main .g-pop-button-copy-icon-box .g-pop-button-copy-icon-tips-box>div {
    margin-top: -0.2rem;
    font-family: MiSans;
    font-weight: 400;
    font-size: 1.33rem;
    color: #ffffff;
    text-align: center;
  }

  .g-pop-box .g-pop-ab-main.g-pop-ab-main_success .g-pop-button-box .g-pop-button-copy-box .g-pop-button-copy-main>svg {
    height: 2rem;
    width: 2rem;
  }

  .g-pop-box .g-pop-ab-main.g-pop-ab-main_success .g-pop-button-box .g-pop-cancle {
    display: none;
  }

  .g-pop-box .g-pop-ab-main.g-pop-ab-main_success .g-pop-main .g-pop-button-box .g-pop-button-button span:nth-child(1) {
    display: none;
  }

  .g-pop-box .g-pop-ab-main.g-pop-ab-main_success .g-pop-main .g-pop-button-box .g-pop-button-button span:nth-child(2) {
    display: block;
  }

  .g-pop-box .g-pop-ab-main.g-pop-ab-main_success .g-pop-main .g-pop-button-box .g-pop-button-button {
    margin-top: 2.25rem;
  }

  @media (max-width:750px) {
    .g-pop-box .g-pop-ab-main {
      width: 100%;
      max-width: calc(100% - 5.5rem);
    }
    .g-pop-box .g-pop-ab-main .g-pop-main .g-pop-close{
      top: 2.3rem;
      right: 2rem;
      width: 1.2rem;
      height: 1.2rem;
    }
    .g-pop-box .g-pop-ab-main .g-pop-main .g-pop-main-bg {
      display: none;
    }

    .g-pop-box .g-pop-ab-main .g-pop-main .g-pop-main-bg.g-pop-main-bg_m {
      display: block;
      width: 100%;
      height: auto;
      object-fit: cover;
    }

    .g-pop-box .g-pop-ab-main .g-pop-main .g-pop-heading {
      column-gap: 1rem;
      margin-top: 1.92rem;
      padding: 0 2rem;
    }

    .g-pop-box .g-pop-ab-main .g-pop-main .g-pop-main-icon {
      width: 3.33rem;
      object-fit: cover;
      height: auto;
      margin-top: 1.92rem;
      margin-left: 2rem;
    }

    .g-pop-box .g-pop-ab-main .g-pop-main .g-pop-title {
      font-size: 2rem;
      padding: 0 2rem;
      flex: 1;
    }

    .g-pop-box .g-pop-ab-main .g-pop-main .g-pop-sub-title {
      margin-bottom:0;
      font-size: 1.17rem;
      padding: 0 2rem;
      flex: 1;
    }

    .g-pop-box .g-pop-ab-main .g-pop-main .g-pop-button-box {
      padding: 1.6rem 2rem 1.67rem;
    }

    .g-pop-box .g-pop-ab-main .g-pop-main .g-pop-button-box .g-pop-button-input {
      font-size: 1.33rem;
      padding: 1.5rem 1rem;
      max-height: 4.17rem;
    }

    .g-pop-box .g-pop-ab-main .g-pop-main .g-pop-button-box .g-pop-button-button {
      border-radius: 0.5rem 0.5rem 0.5rem 0.5rem;
      margin-top: 1.2rem;
      font-size: 1.33rem;
      color: #FFFFFF;
      line-height: 2rem;
    }

    .g-pop-box .g-pop-ab-main .g-pop-main .g-pop-button-box .g-pop-cancle {
      font-size: 1.17rem;
      margin-top: 1.67rem;
    }

    .g-pop-box .g-pop-ab-main.g-pop-ab-main_success .g-pop-main-icon.g-pop-main-icon_success {
      width: 3.33rem;
      object-fit: cover;
      height: auto;
      top: 1.75rem;
      left: 2rem;
    }

    .g-pop-box .g-pop-ab-main.g-pop-ab-main_success .g-pop-main .g-pop-title.g-pop-title_success {
      top: 5.67rem;
      font-size: 2rem;
      left: 2rem;
    }

    .g-pop-box .g-pop-ab-main.g-pop-ab-main_success .g-pop-main .g-pop-sub-title.g-pop-sub-title_success {
      top: 11.5rem;
      left: 2rem;
      font-weight: 400;
      font-size: 1.17rem;
      color: #000000;
    }

    .g-pop-box .g-pop-ab-main.g-pop-ab-main_success .g-pop-button-box {
      padding: 3rem 2rem 2.92rem;
    }

    .g-pop-box .g-pop-ab-main.g-pop-ab-main_success .g-pop-button-box .g-pop-button-copy-box .g-pop-button-copy-bg {
      display: none;
    }

    .g-pop-box .g-pop-ab-main.g-pop-ab-main_success .g-pop-button-box .g-pop-button-copy-box .g-pop-button-copy-bg.g-pop-button-copy-bg_m {
      display: block;
      width: 100%;
      object-fit: cover;
      height: auto;
      z-index:9;
    }

    .g-pop-box .g-pop-ab-main.g-pop-ab-main_success .g-pop-button-box .g-pop-button-copy-box .g-pop-button-copy-main {
      font-weight: 400;
      font-size: 1.33rem;
      white-space: nowrap;
    }

    .g-pop-box .g-pop-ab-main.g-pop-ab-main_success .g-pop-button-box .g-pop-button-copy-box {
      width: 100%;
    }

    .g-pop-box .g-pop-ab-main.g-pop-ab-main_success .g-pop-button-box .g-pop-button-copy-box .g-pop-button-copy-main .g-pop-button-copy-icon-box>svg {
      width: 1.72rem;
      height: auto;
      object-fit: cover;
    }

    .g-pop-box .g-pop-ab-main.g-pop-ab-main_success .g-pop-button-box .g-pop-button-copy-box .g-pop-button-copy-main>span:nth-child(2) {
      margin-right: 0.17rem;
    }

    .g-pop-box .g-pop-ab-main.g-pop-ab-main_success .g-pop-button-box .g-pop-button-copy-box .g-pop-button-copy-main .g-pop-button-copy-icon-box .g-pop-button-copy-icon-tips-box>div {
      font-size: 1.11rem;
      color: #FFFFFF;
      text-align: center;
    }

    .g-pop-box .g-pop-ab-main.g-pop-ab-main_success .g-pop-button-box .g-pop-button-copy-box .g-pop-button-copy-main .g-pop-button-copy-icon-box .g-pop-button-copy-icon-tips-box>svg {
      width: 1.39rem;
      height: auto;
      object-fit: cover;
    }

    .g-pop-box .g-pop-ab-main.g-pop-ab-main_success .g-pop-main .g-pop-button-box .g-pop-button-button {
      margin-top: 1.67rem;
    }

    .g-pop-box .g-pop-ab-main .g-pop-main .g-pop-button-box .g-pop-button-error-text {
      font-size: 1.17rem;
    }
  }
    `;
        document.head.appendChild(style);
    }

    function createHTML() {
        return `
      <div class="g-pop-box">
        <div class="g-pop-mark"></div>
        <div class="g-pop-ab-main">
          <div class="g-pop-main">
            <button class="g-pop-close" type="button" aria-label="Close">
              <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="m9.414 8 6.293-6.293A1 1 0 0 0 14.293.293L8 6.586 1.707.293A1 1 0 1 0 .293 1.707L6.586 8 .293 14.293a1 1 0 1 0 1.414 1.414L8 9.414l6.293 6.293a.997.997 0 0 0 1.631-.324 1 1 0 0 0-.217-1.09L9.414 8Z" fill="#6C6B80" />
              </svg>
            </button>
            <svg width="619" class="g-pop-main-bg" height="349" viewBox="0 0 619 349" fill="none"
              xmlns="http://www.w3.org/2000/svg">
              <g id="Mask group" opacity="0.64">
                <mask id="mask0_7606_6917" style="mask-type: alpha" maskUnits="userSpaceOnUse" x="0" y="0" width="619"
                  height="349">
                  <rect id="Rectangle 545078" width="619" height="349" rx="16" fill="white" />
                </mask>
                <g mask="url(#mask0_7606_6917)">
                  <g id="Ellipse 1337" opacity="0.3" filter="url(#filter0_f_7606_6917)">
                    <ellipse cx="373" cy="-12.5" rx="262" ry="60.5" fill="#005FFC" />
                  </g>
                  <g id="Ellipse 1338" opacity="0.3" filter="url(#filter1_f_7606_6917)">
                    <ellipse cx="586" cy="-5.5" rx="262" ry="60.5" fill="#00A0FC" />
                  </g>
                </g>
              </g>
              <defs>
                <filter id="filter0_f_7606_6917" x="-39" y="-223" width="824" height="421" filterUnits="userSpaceOnUse"
                  color-interpolation-filters="sRGB">
                  <feFlood flood-opacity="0" result="BackgroundImageFix" />
                  <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
                  <feGaussianBlur stdDeviation="75" result="effect1_foregroundBlur_7606_6917" />
                </filter>
                <filter id="filter1_f_7606_6917" x="174" y="-216" width="824" height="421" filterUnits="userSpaceOnUse"
                  color-interpolation-filters="sRGB">
                  <feFlood flood-opacity="0" result="BackgroundImageFix" />
                  <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
                  <feGaussianBlur stdDeviation="75" result="effect1_foregroundBlur_7606_6917" />
                </filter>
              </defs>
            </svg>
            <svg width="310" class="g-pop-main-bg g-pop-main-bg_m" height="174" viewBox="0 0 310 174" fill="none"
              xmlns="http://www.w3.org/2000/svg">
              <g id="Mask group" opacity="0.64">
                <mask id="mask0_7698_9374" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="0" y="0" width="310"
                  height="174">
                  <rect id="Rectangle 545078" width="310" height="174" rx="8.01292" fill="white" />
                </mask>
                <g mask="url(#mask0_7698_9374)">
                  <g id="Ellipse 1337" opacity="0.3" filter="url(#filter0_f_7698_9374)">
                    <ellipse cx="186.801" cy="-6.23121" rx="131.212" ry="30.1633" fill="#005FFC" />
                  </g>
                  <g id="Ellipse 1338" opacity="0.3" filter="url(#filter1_f_7698_9374)">
                    <ellipse cx="293.473" cy="-2.74097" rx="131.212" ry="30.1633" fill="#00A0FC" />
                  </g>
                </g>
              </g>
              <defs>
                <filter id="filter0_f_7698_9374" x="-19.5313" y="-111.516" width="412.666" height="210.568"
                  filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                  <feFlood flood-opacity="0" result="BackgroundImageFix" />
                  <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
                  <feGaussianBlur stdDeviation="37.5606" result="effect1_foregroundBlur_7698_9374" />
                </filter>
                <filter id="filter1_f_7698_9374" x="87.1406" y="-108.025" width="412.666" height="210.568"
                  filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                  <feFlood flood-opacity="0" result="BackgroundImageFix" />
                  <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
                  <feGaussianBlur stdDeviation="37.5606" result="effect1_foregroundBlur_7698_9374" />
                </filter>
              </defs>
            </svg>

            <div class="g-pop-heading">
              <svg class="g-pop-main-icon" width="80" height="80" viewBox="0 0 80 80" fill="none"
                xmlns="http://www.w3.org/2000/svg">
              <g id="icon_标记_dark" clip-path="url(#clip0_7606_6926)">
                <path id="Union" fill-rule="evenodd" clip-rule="evenodd"
                  d="M16.0801 39.7412L16.082 14.8857L40.9355 14.8857L67.6571 41.6073L42.8017 66.4628L16.0801 39.7412ZM13.9155 9.88574C12.3508 9.88574 11.0823 11.1542 11.0822 12.7189L11.0801 40.6384C11.08 41.3899 11.3785 42.1107 11.9099 42.6421L40.7982 71.5304C41.9047 72.6369 43.6987 72.6368 44.8051 71.5304L72.7247 43.6108C73.8312 42.5043 73.8312 40.7104 72.7247 39.6039L43.8364 10.7156C43.3051 10.1843 42.5844 9.88574 41.833 9.88574H13.9155ZM32.6571 27.4092C32.6571 29.5811 30.8964 31.3417 28.7246 31.3417C26.5528 31.3417 24.7922 29.5811 24.7922 27.4092C24.7922 25.2374 26.5528 23.4768 28.7246 23.4768C30.8964 23.4768 32.6571 25.2374 32.6571 27.4092Z"
                  fill="#005FFC" />
              </g>
              <defs>
                <clipPath id="clip0_7606_6926">
                  <rect width="80" height="80" fill="white" />
                </clipPath>
              </defs>
              </svg>
              <div class="g-pop-title g-pop-title-first-line">
                Save <span class="g-pop-title-highlight">5%</span>
              </div>
              <div class="g-pop-title g-pop-title-second-line">on Your First Order</div>
            </div>
            <svg class="g-pop-main-icon g-pop-main-icon_success" width="65" height="65" viewBox="0 0 65 65" fill="none"
              xmlns="http://www.w3.org/2000/svg">
              <path id="Union" fill-rule="evenodd" clip-rule="evenodd"
                d="M32.5 0C23.5261 0 15.3977 3.64043 9.51904 9.51901L9.51901 9.51904C3.64043 15.3977 0 23.5261 0 32.5C0 41.4739 3.64043 49.6023 9.51902 55.4809L11.2868 53.7132L9.51903 55.4809C15.3977 61.3595 23.5261 65 32.5 65C41.4739 65 49.6023 61.3595 55.4809 55.4809C61.3595 49.6023 65 41.4739 65 32.5C65 23.5261 61.3595 15.3977 55.4809 9.51903L53.7132 11.2868L55.4809 9.51902C49.6023 3.64043 41.4739 0 32.5 0ZM13.0545 13.0546C18.0339 8.0753 24.9055 5 32.5 5C40.0945 5 46.9661 8.07531 51.9454 13.0546C56.9247 18.0339 60 24.9055 60 32.5C60 40.0945 56.9247 46.9661 51.9454 51.9454C46.9661 56.9247 40.0945 60 32.5 60C24.9055 60 18.0339 56.9247 13.0546 51.9454C8.07531 46.9661 5 40.0945 5 32.5C5 24.9055 8.07528 18.0339 13.0545 13.0546ZM48.3977 25.0685C49.374 24.0922 49.374 22.5093 48.3977 21.533C47.4214 20.5567 45.8385 20.5567 44.8622 21.533L28.2364 38.1588L20.1369 30.0593C19.1606 29.083 17.5777 29.083 16.6014 30.0593C15.6251 31.0356 15.6251 32.6185 16.6014 33.5948L26.2329 43.2264C27.3394 44.3329 29.1334 44.3329 30.2399 43.2264L48.3977 25.0685Z"
                fill="#1FCC75" />
            </svg>
            <div class="g-pop-title g-pop-title_success">
              Thanks for <br />Subscribing
            </div>
            <div class="g-pop-sub-title">
              Be the first to access new product launches and exclusive deals.
            </div>
            <div class="g-pop-sub-title g-pop-sub-title_success">
              Your offer is ready.
            </div>
            <div class="g-pop-button-box">
              <input class="g-pop-button-input" placeholder="Email address" />
              <div class="g-pop-button-error-text"></div>
              <div class="g-pop-button-copy-box">
                <svg class="g-pop-button-copy-bg" width="523" height="58" viewBox="0 0 523 58" fill="none"
                  xmlns="http://www.w3.org/2000/svg">
                  <path id="Subtract" opacity="0.1"
                    d="M515 0C519.418 0 523 3.58172 523 8V12C519.134 12 516 15.134 516 19C516 22.866 519.134 26 523 26V32C519.134 32 516 35.134 516 39C516 42.866 519.134 46 523 46V50C523 54.4183 519.418 58 515 58H8C3.58172 58 0 54.4183 0 50V46C3.86599 46 7 42.866 7 39C7 35.134 3.86599 32 0 32V26C3.86599 26 7 22.866 7 19C7 15.134 3.86599 12 0 12V8C5.15405e-07 3.58172 3.58172 0 8 0H515Z"
                    fill="#005FFC" />
                </svg>
                <svg class="g-pop-button-copy-bg g-pop-button-copy-bg_m" width="262" height="50" viewBox="0 0 262 50"
                  fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path id="Subtract" opacity="0.1"
                    d="M254.604 0C258.412 0 261.5 3.08766 261.5 6.89648V10.3428C258.183 10.3615 255.5 13.0561 255.5 16.377C255.5 19.6981 258.183 22.3924 261.5 22.4111V27.584C258.183 27.6027 255.5 30.2981 255.5 33.6191C255.5 36.9401 258.183 39.6336 261.5 39.6523V43.1035C261.5 46.9123 258.412 50 254.604 50H7.39648C3.58785 49.9998 0.500037 46.9122 0.5 43.1035V39.6523C0.511713 39.6524 0.523428 39.6533 0.535156 39.6533C3.8676 39.6531 6.56912 36.9516 6.56934 33.6191C6.56928 30.2866 3.86771 27.5842 0.535156 27.584C0.52343 27.584 0.51171 27.5839 0.5 27.584V22.4111C0.511713 22.4112 0.523428 22.4121 0.535156 22.4121C3.86774 22.4119 6.56934 19.7096 6.56934 16.377C6.56906 13.0446 3.86757 10.343 0.535156 10.3428C0.52343 10.3428 0.51171 10.3427 0.5 10.3428V6.89648C0.500037 3.0878 3.58785 0.000234556 7.39648 0H254.604Z"
                    fill="#005FFC" />
                </svg>

                <div class="g-pop-button-copy-main">
                  <span>Code:&nbsp;&nbsp;</span>
                  <span>TOPDON</span>
                  <div class="g-pop-button-copy-icon-box">
                    <div class="g-pop-button-copy-icon-tips-box">
                      <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <g id="Frame">
                          <path id="Vector" d="M17.9173 4.58398L7.0319 15.4173L2.08398 10.4931" stroke="white"
                            stroke-width="1.66667" stroke-linecap="round" stroke-linejoin="round" />
                        </g>
                      </svg>
                      <div>Copied</div>
                    </div>
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <g id="icon_复制_dark" clip-path="url(#clip0_7542_6521)">
                        <path id="Union" fill-rule="evenodd" clip-rule="evenodd"
                          d="M6.0248 2.82227C5.55536 2.82227 5.1748 3.20283 5.1748 3.67227V4.31641H17.9842C18.9231 4.31641 19.6842 5.07752 19.6842 6.01641V18.6891H20.3238C20.7933 18.6891 21.1738 18.3085 21.1738 17.8391V5.57227C21.1738 4.05348 19.9426 2.82227 18.4238 2.82227H6.0248ZM3.67031 5.31836C3.20087 5.31836 2.82031 5.69892 2.82031 6.16836V20.3352C2.82031 20.8046 3.20088 21.1852 3.67031 21.1852H17.8371C18.3066 21.1852 18.6871 20.8046 18.6871 20.3352V6.16836C18.6871 5.69891 18.3066 5.31836 17.8371 5.31836H3.67031ZM4.32031 19.6852V6.81836H17.1871V19.6852H4.32031Z"
                          fill="#005FFC" />
                      </g>
                      <defs>
                        <clipPath id="clip0_7542_6521">
                          <rect width="24" height="24" fill="white" />
                        </clipPath>
                      </defs>
                    </svg>
                  </div>
                </div>
              </div>
              <div class="g-pop-button-button">
                <span>UNLOCK 5% OFF</span>
                <span>Shop Now</span>
              </div>
              <div class="g-pop-cancle">No, thanks</div>
            </div>
          </div>
        </div>
      </div>
    `;
    }

    function gPopClose() {
        document.body.style.overflow = "";
        const allBox = document.querySelector(".g-pop-box");
        if (allBox) {
            document.body.removeChild(allBox);
        }
        setCooldown();
    }

    function gPopInit() {
        document.body.style.overflow = "hidden";
    }

    function isValidEmail(email) {
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        return emailRegex.test(email);
    }

    function initSubscribePopup(config = { siteFrom: "EU" }) {
        const unlockButton = document.querySelector(".g-pop-button-button");
        const emailInput = document.querySelector(".g-pop-button-input");
        const errorText = document.querySelector(".g-pop-button-error-text");
        const popBox = document.querySelector(".g-pop-ab-main");
        const cancelButton = document.querySelector(".g-pop-cancle");
        const closeButton = document.querySelector(".g-pop-close");
        const copyIconBox = document.querySelector(".g-pop-button-copy-icon-box");
        const copyTips = document.querySelector(".g-pop-button-copy-icon-tips-box");

        let copyTrackingSent = false;

        unlockButton.addEventListener("click", function (e) {
            // 如果按钮处于禁用状态，阻止点击
            if (unlockButton.classList.contains("g-pop-button-button_not")) {
                return;
            }

            if (popBox.classList.contains("g-pop-ab-main_success")) {
                gPopClose();
                return;
            }

            const email = emailInput.value.trim();
            errorText.style.display = "none";
            emailInput.classList.remove("g-pop-button-input_error");

            if (!isValidEmail(email)) {
                errorText.textContent = "Please enter valid email address!";
                errorText.style.display = "block";
                emailInput.classList.add("g-pop-button-input_error");
                return;
            }

            unlockButton.classList.add("g-pop-button-button_not");

            const xhr = new XMLHttpRequest();
            xhr.open(
                "POST",
                "https://official-web-api.topdon.com/api/subscribe",
                true
            );
            xhr.setRequestHeader("Content-type", "application/x-www-form-urlencoded");
            xhr.setRequestHeader("X-Requested-With", "Hiwie-Fetch");

            xhr.onreadystatechange = function () {
                if (xhr.readyState === 4) {
                    unlockButton.classList.remove("g-pop-button-button_not");

                    if (xhr.status >= 200 && xhr.status < 300) {
                        try {
                            const result = JSON.parse(xhr.responseText);
                            console.log("API Response:", result);
                            console.log("Response status:", xhr.status);

                            if (!result.error) {
                                popBox.classList.add("g-pop-ab-main_success");
                            } else {
                                const errorMessage =
                                    result.error.message || "Subscription failed";
                                errorText.textContent = errorMessage;
                                errorText.style.display = "block";
                                emailInput.classList.add("g-pop-button-input_error");
                            }
                        } catch (parseError) {
                            console.error("JSON parse error:", parseError);
                            errorText.textContent =
                                "Subscription failed, please try again later";
                            errorText.style.display = "block";
                            emailInput.classList.add("g-pop-button-input_error");
                        }
                    } else {
                        console.error("HTTP error:", xhr.status);
                        errorText.textContent =
                            "Subscription failed, please try again later";
                        errorText.style.display = "block";
                        emailInput.classList.add("g-pop-button-input_error");
                    }
                }
            };

            xhr.onerror = function () {
                unlockButton.classList.remove("g-pop-button-button_not");
                console.error("Network error");
                errorText.textContent = "Subscription failed, please try again later";
                errorText.style.display = "block";
                emailInput.classList.add("g-pop-button-input_error");
            };

            xhr.send(
                `email=${encodeURIComponent(email)}&siteFrom=${config.siteFrom
                }&from=POP`
            );
        });

        copyIconBox.addEventListener("click", function () {
            sendCopyTrackingRequest();
            copyTextToClipboard("TOPDON");
        });

        function copyTextToClipboard(text) {
            if (navigator.clipboard && window.isSecureContext) {
                navigator.clipboard
                    .writeText(text)
                    .then(function () {
                        showCopySuccess();
                    })
                    .catch(function () {
                        execCommandCopy(text);
                    });
            } else {
                execCommandCopy(text);
            }
        }

        function execCommandCopy(text) {
            const textArea = document.createElement("textarea");
            textArea.value = text;
            textArea.style.position = "fixed";
            textArea.style.left = "-999999px";
            textArea.style.top = "-999999px";
            document.body.appendChild(textArea);
            textArea.focus();
            textArea.select();

            try {
                const successful = document.execCommand("copy");
                if (successful) {
                    showCopySuccess();
                } else {
                    fallbackCopyTextToClipboard(text);
                }
            } catch (err) {
                console.error("execCommand copy failed: ", err);
                fallbackCopyTextToClipboard(text);
            } finally {
                document.body.removeChild(textArea);
            }
        }

        function sendCopyTrackingRequest() {
            try {
                if (copyTrackingSent) {
                    console.log("Copy tracking already sent, skipping");
                    return;
                }

                const email = emailInput.value.trim();

                if (!email) {
                    console.log("No email found, skipping copy tracking");
                    return;
                }
                copyTrackingSent = true;
                const xhr = new XMLHttpRequest();
                xhr.open(
                    "POST",
                    "https://official-web-api.topdon.com/api/subscribe/copiedDiscountCode",
                    true
                );
                xhr.setRequestHeader(
                    "Content-type",
                    "application/x-www-form-urlencoded"
                );
                xhr.setRequestHeader("X-Requested-With", "Hiwie-Fetch");

                xhr.onreadystatechange = function () {
                    if (xhr.readyState === 4) {
                        if (xhr.status >= 200 && xhr.status < 300) {
                            console.log("Copy tracking sent successfully:", xhr.status);
                        } else {
                            console.log("Copy tracking failed (不影响用户操作):", xhr.status);
                        }
                    }
                };

                xhr.onerror = function () {
                    console.log("Copy tracking failed (不影响用户操作): Network error");
                };

                xhr.send(
                    `email=${encodeURIComponent(email)}&siteFrom=${config.siteFrom
                    }&from=POP`
                );
            } catch (error) {
                console.log("Copy tracking error (不影响用户操作):", error.message);
            }
        }

        function showCopySuccess() {
            copyTips.classList.add("g-pop-button-copy-icon-tips-box_active");
            setTimeout(() => {
                copyTips.classList.remove("g-pop-button-copy-icon-tips-box_active");
            }, 2000);
        }

        function fallbackCopyTextToClipboard(text) {
            const modal = document.createElement("div");
            modal.style.cssText = `
        position: fixed;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background: rgba(0,0,0,0.8);
        display: flex;
        align-items: center;
        justify-content: center;
        z-index: 10000;
        font-family: Arial, sans-serif;
      `;

            const content = document.createElement("div");
            content.style.cssText = `
        background: white;
        padding: 20px;
        border-radius: 8px;
        text-align: center;
        max-width: 400px;
        box-shadow: 0 4px 20px rgba(0,0,0,0.3);
      `;

            const title = document.createElement("h3");
            title.textContent = "Copy Discount Code";
            title.style.cssText = "margin: 0 0 15px 0; color: #333;";

            const input = document.createElement("input");
            input.type = "text";
            input.value = text;
            input.readOnly = true;
            input.style.cssText = `
        width: 100%;
        padding: 10px;
        margin: 10px 0;
        border: 2px solid #005ffc;
        border-radius: 4px;
        text-align: center;
        font-size: 16px;
        font-weight: bold;
        background: #f0f8ff;
        box-sizing: border-box;
      `;

            const instruction = document.createElement("p");
            instruction.textContent =
                "Please select the code above and copy it manually (Ctrl+C / Cmd+C)";
            instruction.style.cssText =
                "margin: 10px 0; color: #666; font-size: 14px;";

            const closeBtn = document.createElement("button");
            closeBtn.textContent = "Close";
            closeBtn.style.cssText = `
        background: #005ffc;
        color: white;
        border: none;
        padding: 10px 20px;
        border-radius: 4px;
        cursor: pointer;
        margin-top: 10px;
        font-size: 14px;
      `;

            content.appendChild(title);
            content.appendChild(input);
            content.appendChild(instruction);
            content.appendChild(closeBtn);
            modal.appendChild(content);
            document.body.appendChild(modal);

            input.focus();
            input.select();

            function closeModal() {
                if (document.body.contains(modal)) {
                    document.body.removeChild(modal);
                }
                showCopySuccess();
            }

            closeBtn.addEventListener("click", closeModal);
            modal.addEventListener("click", function (e) {
                if (e.target === modal) closeModal();
            });

            function escapeHandler(e) {
                if (e.key === "Escape") {
                    closeModal();
                    document.removeEventListener("keydown", escapeHandler);
                }
            }
            document.addEventListener("keydown", escapeHandler);
        }

        cancelButton.addEventListener("click", gPopClose);
        closeButton.addEventListener("click", gPopClose);

        emailInput.addEventListener("input", function () {
            errorText.style.display = "none";
            errorText.textContent = "";
            emailInput.classList.remove("g-pop-button-input_error");
        });
    }

    function init(config = { siteFrom: "EU" }) {
        if (checkCooldown()) {
            console.log("弹窗在冷却期内,3天内不再显示");
            return;
        }

        injectCSS();

        const popupHTML = createHTML();
        const tempDiv = document.createElement("div");
        tempDiv.innerHTML = popupHTML;
        const popupElement = tempDiv.firstElementChild;
        document.body.appendChild(popupElement);
        gPopInit();
        initSubscribePopup(config);
    }

    if (document.readyState === "loading") {
        document.addEventListener("DOMContentLoaded", function () {
            init({ siteFrom: "EU" });
        });
    } else {
        init({ siteFrom: "EU" });
    }

    window.GPopBox = {
        init: init,
        close: gPopClose,
    };
})();
